/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, OnInit,EventEmitter, Output, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CommonService } from '../services/common.service';

@Component({
  selector: 'cc-report-filter-modal',
  templateUrl: './filter-modal.component.html',
  styleUrls: ['./filter-modal.component.scss']
})

export class ReportFilterModalComponent implements OnInit {
  @Input() num1!: number;
  @Input() num2!: number;
  @Output() onClose = new EventEmitter<string>();
  public allFilters: any = [];
  public selectedFiltersCount: any = {};
  public selectedFilters: Array<any> = [];
  public userMessage = '';
  public objectKeys = Object.keys;
  public globalFilterValue: any = '';

  constructor(public bsModalRef: BsModalRef, private commonService: CommonService) {
    this.commonService.filterChange.subscribe(() => {
      this.selectedFilters = [];
      this.getAllFilterDetails();
    });
  }

  ngOnInit() {
    this.selectedFilters = [];
    this.getAllFilterDetails();
  }

  public getTranslationWithKey(key: any) {
    return this.commonService.getTranslatedVal(key);
  }

  private getAllFilterDetails() {
    this.allFilters = this.commonService.getAllFilters();
    for (const filterGroup of this.allFilters) {
      filterGroup.groupFilters = {};
      for (const filter of filterGroup.filters) {
        if (filterGroup.groupFilters[filter['groupName']]) {
          filterGroup.groupFilters[filter['groupName']].push(filter);
        } else {
          if (!filter['groupName']) {
            filter['groupName'] = 'default';
          }
          if (!filterGroup.groupFilters[filter['groupName']]) {
            filterGroup.groupFilters[filter['groupName']] = [];
          }
          filterGroup.groupFilters[filter['groupName']].push(filter);
        }
      }
    }
    this.prepareCheckedFilters();
    this.selectedFiltersByFilterset();
    if (this.allFilters.length) {
      this.displayFilters(this.allFilters[0]);
    } else {
      this.userMessage = this.getTranslationWithKey('afm_filter_not_available');
    }
  }

  private prepareCheckedFilters() {
    const selectedFilters = this.commonService.getSelectedFilters();

    /* Prepare the unique filterSet and their filters object first */
    const tempObj: any = {};
    for (const item of selectedFilters) {
      const filterSet = item.filterSetBelongsTo;
      if (tempObj[filterSet]) {
        tempObj[filterSet].push(item.name);
      } else {
        tempObj[filterSet] = [];
        tempObj[filterSet].push(item.name);
      }
    }
    /* Match the filterset and loop the original list of filters to check and uncheck */
    let filtersToBeSelected;
    const filterSets = Object.keys(tempObj);
    for (const filterSet of this.allFilters) {
      if (filterSets.indexOf(filterSet.name) > -1) {
        const originalFilters = filterSet.filters;
        filtersToBeSelected = tempObj[filterSet.name];
        for (const filter of originalFilters) {
          if (filtersToBeSelected.indexOf(filter.name) > -1) {
            filter.isChecked = true;
          } else {
            filter.isChecked = false;
          }
        }
      } else {
        /* make everything uncheck here */
        for (const filter of filterSet.filters) {
          filter.isChecked = false;
        }
      }
    }
  }

  private selectedFiltersByFilterset() {
    this.selectedFiltersCount = {};
    this.selectedFilters = [];
    for (const filterset of this.allFilters) {
      let filterSetCount = 0;
      for (const filter of filterset.filters) {
        if (filter.isChecked) {
          filterSetCount++;
          let tempFilterObj: any = {};
          tempFilterObj = filter;
          tempFilterObj.filterSetBelongsTo = filterset.name;
          this.selectedFilters.push(tempFilterObj);
        }
      }
      this.selectedFiltersCount[filterset.name] = filterSetCount;
    }
  }

  private resetFilterOptions() {
    for (const filterset of this.allFilters) {
      filterset.visible = false;
    }
  }

  public displayFilters(filterSetObj: any) {
    this.resetFilterOptions();
    filterSetObj.visible = true;
  }

  public onFilterSelectionChange() {
    this.selectedFiltersByFilterset();
  }

  public closeModalWindow() {
    this.onClose.emit('closed');
    this.bsModalRef.hide();
  }

  public saveModalContent() {
    this.commonService.setSelectedFilters(this.selectedFilters);
    this.onClose.emit('saved');
    this.bsModalRef.hide();
  }

  public clearAllFilters() {
    for (const filterSet of this.allFilters) {
      for (const filter of filterSet.filters) {
        filter.isChecked = false;
      }
    }
    this.selectedFiltersByFilterset();
  }

  public selectAllFilters() {
    for (const filterSet of this.allFilters) {
      for (const filter of filterSet.filters) {
        filter.isChecked = true;
      }
    }
    this.selectedFiltersByFilterset();
  }

  public search(evt: any) {
    setTimeout(() => {
      this.showFilters(0);
    }, 100);
  }

  public clearFilter() {
    this.globalFilterValue = '';
    setTimeout(() => {
      this.showFilters(0);
    }, 100);
  }

  public showFilters(index: any) {
    this.resetFilterOptions();
    index = this.incIndex(index);
    if (this.allFilters[index]) {
      this.allFilters[index].visible = true;
      this.displayRelatedFilters(index, 0);
    }
  }

  public displayRelatedFilters(index: any, relIndex: any) {
    index = this.incIndex(index);
    this.resetRelatedFilterSets(index);
    if (this.allFilters[index] && this.allFilters[index].filters) {
      relIndex = this.incSubIndex(index, relIndex);
      if (this.allFilters[index].filters.length && this.allFilters[index].filters[relIndex]) {
        this.allFilters[index].filters[relIndex].visible = true;
      }
    }
  }

  private resetRelatedFilterSets(index: any) {
    if (this.allFilters[index] && this.allFilters[index].filters) {
      for (const filterSet of this.allFilters[index].filters) {
        filterSet.visible = false;
      }
    }
  }

  private incIndex(index: any) {
    let inc = -1,
      finVal;
    for (let i = 0; i < this.allFilters.length; i++) {
      if (this.allFilters[i] && this.allFilters[i].show) {
        inc = inc + 1;
        if (index == inc) {
          finVal = i;
          break;
        }
      }
    }
    return finVal;
  }

  private incSubIndex(index: any, relIndex: any) {
    let inc = -1,
      finVal;
    for (let i = 0; i < this.allFilters[index].filters.length; i++) {
      if (this.allFilters[index].filters[i] && this.allFilters[index].filters[i].show) {
        inc = inc + 1;
        if (relIndex == inc) {
          finVal = i;
          break;
        }
      }
    }
    return finVal;
  }
}
